import Lottie from "lottie-react";
import { Placeholder } from "rsuite";
import { ToastContainer } from "react-toastify";

import dietLoading from "../../animations/diet_loading.json";

import "./valley.scss";
import "react-toastify/dist/ReactToastify.css";

const Valley = (props) => {
  return (
    <>
      <div className="container valley">
        <div className="form-container">
          <div className="center">
            <Placeholder.Paragraph rows={8} />
            <Lottie animationData={dietLoading} loop={true} />
            <div>درحال بارگذاری ...</div>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default Valley;
